import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';

export function GroupAccordion({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  function toggle() {
    setIsOpen(!isOpen);
  }

  return (
    <div className="bg-gray-100 dark:bg-gray-500/40 mb-4 p-4 rounded-md group-accordion">
      <legend
        className="font-bold text-lg text-black dark:text-gray-100 flex items-center cursor-pointer"
        onClick={toggle}
      >
        {name}
        <ChevronDownIcon
          className={`w-5 h-5 ml-2 ${isOpen ? 'transform rotate-180' : ''}`}
        />
      </legend>
      <div className={`${isOpen ? 'block' : 'hidden'}`}>
        <div className="mt-2">{children}</div>
      </div>
    </div>
  );
}
